import { getQueryParameters, getIncludeNotHeldParameter, getSimulateActionsNode, getUsageParameters, getContributorDescriptors, getContentSetParameter, getAnalyticsOutputParameter } from "./helpers"

export function exposureQuery(options = {}) {
  const parameters = [getAnalyticsOutputParameter(options)]
  return `query (${getQueryParameters(parameters)}) {
    model (id: $modelId) {
      simulation: ${getSimulateActionsNode(parameters)} {
        ${exposureQueryFragment()}
      }
    }
  }`
}

export function exposureQueryFragment() {
  return `exposure {
    factors {
      id
      category
      netContribution: net
      currencyExposure
    }
  }`
}

export function exposureContributorsQuery(options = {}) {
  const includeNotHeldParameter = getIncludeNotHeldParameter(options)
  const analyticsOuputParameter = getAnalyticsOutputParameter(options)
  return `query (${getQueryParameters([analyticsOuputParameter, includeNotHeldParameter])}) {
    model (id: $modelId) {
      simulation: ${getSimulateActionsNode([analyticsOuputParameter])} {
        ${exposureContributorsQueryFragment([includeNotHeldParameter])}
      }
    }
  }`
}

export function exposureContributorsQueryFragment(parameters = []) {
  return `exposureContributors ${getUsageParameters(parameters, true)} {
    date
    contributors {
      ${getContributorDescriptors()}
      factors {
        id
        name
        category
        netContribution
        currencyExposure
        assetZScore: securityExposure
      }
    }
  }`
}

export function contentSetExposureQuery(contentSet, options = {}) {
  const contentSetParameter = getContentSetParameter(contentSet)
  const analyticsOuputParameter = getAnalyticsOutputParameter(options)

  return `query (${getQueryParameters([analyticsOuputParameter, contentSetParameter])}) {
    model (id: $modelId) {
      simulation: ${getSimulateActionsNode([analyticsOuputParameter])} {
        ${contentSetExposureQueryFragment(contentSet)}
      }
    }
  }`
}

export function contentSetExposureQueryFragment(contentSet) {
  if (!contentSet) { return "" }
  const { escapedId } = contentSet

  return `${escapedId}_exposure: exposure(contentSetId: $contentSetId){
    factors{
      id
      category
      netContribution: net,
      currencyExposure
    }
  }`
}

export function contentSetExposureContributorsQuery(contentSet, options = {}) {
  const includeNotHeldParameter = getIncludeNotHeldParameter(options)
  const contentSetParameter = getContentSetParameter(contentSet)
  const analyticsOuputParameter = getAnalyticsOutputParameter(options)

  return `query(${getQueryParameters([analyticsOuputParameter, includeNotHeldParameter, contentSetParameter])}) {
    model (id: $modelId) {
      simulation: ${getSimulateActionsNode([analyticsOuputParameter])} {
        ${contentSetExposureContributorsQueryFragment(contentSet, [includeNotHeldParameter, contentSetParameter])}
      }
    }
  }`
}

export function contentSetExposureContributorsQueryFragment(contentSet, parameters = []) {
  if (!contentSet) { return "" }
  const { escapedId } = contentSet
  return `${escapedId}: exposureContributors ${getUsageParameters(parameters, true)}{
    date
    contributors {
      ${getContributorDescriptors()}
      factors {
        id
        name
        category
        netContribution
        currencyExposure
        assetZScore: securityExposure
      }
    }
  }`
}

export function groupedExposureContributorsQuery(options = {}) {
  const includeNotHeldParameter = getIncludeNotHeldParameter(options)
  const analyticsOuputParameter = getAnalyticsOutputParameter(options)
  return `query (${getQueryParameters([analyticsOuputParameter, includeNotHeldParameter], true)}) {
    model (id: $modelId) {
      simulation: ${getSimulateActionsNode([analyticsOuputParameter])} {
        ${groupedExposureContributorsQueryFragment([includeNotHeldParameter])}
      }
    }
  }`
}

export function groupedExposureContributorsQueryFragment(parameters = []) {
  return `groupedExposureContributors(groupBy: $groupBy, groupById: $groupById, classificationTier: $tier ${getUsageParameters(parameters)}) {
    date
    groupedContributors {
      id
      name
      factors {
        id
        name
        category
        netContribution
        currencyExposure
      }
      contributors{
        ${getContributorDescriptors()}
        factors {
          id
          name
          category
          netContribution
          currencyExposure
          assetZScore: securityExposure
        }
      }
    }
  }`
}

export function groupedContentSetExposureContributorsQuery(contentSet, options = {}) {
  const includeNotHeldParameter = getIncludeNotHeldParameter(options)
  const contentSetParameter = getContentSetParameter(contentSet)
  const analyticsOuputParameter = getAnalyticsOutputParameter(options)
  return `query (${getQueryParameters([analyticsOuputParameter, includeNotHeldParameter, contentSetParameter], true)}) {
    model (id: $modelId) {
      simulation: ${getSimulateActionsNode([analyticsOuputParameter])} {
        ${groupedContentSetExposureContributorsQueryFragment(contentSet, [includeNotHeldParameter, contentSetParameter])}
      }
    }
  }`
}

export function groupedContentSetExposureContributorsQueryFragment(contentSet, parameters = []) {
  if (!contentSet) { return "" }
  const { escapedId } = contentSet

  return `${escapedId}_grouped: groupedExposureContributors(groupBy: $groupBy, groupById: $groupById, classificationTier: $tier ${getUsageParameters(parameters)}){
    date
    groupedContributors {
      id
      name
      factors {
        id
        name
        category
        netContribution
        currencyExposure
      }
      contributors{
        ${getContributorDescriptors()}
        factors {
          id
          name
          category
          netContribution
          currencyExposure
          assetZScore: securityExposure
        }
      }
    }
  }`
}
